import React from 'react';
import { Link } from 'react-router-dom';
import PreviewPublishContent from '../../../common/ui/PreviewPublishContent';
import ProductionPublishContent from '../../../common/ui/ProductionPublishContent';
import HeaderAnchorPopover from './HeaderAnchorPopover';

export const PUBLISH_TRIGGER_ID = 'dc-publish-trigger';
const PUBLISH_PANEL_ID = 'dc-publish-panel';

const PublishPopover = ({
  isOpen,
  toggle,
  projectId,
  version,
  versions,
  selVersion,
  isPublishing,
  isPreviewPublishing,
  handleVersionChange,
  publishApp,
  projectDetail,
  actions,
}) => {
  return (
    <HeaderAnchorPopover
      targetId={PUBLISH_TRIGGER_ID}
      panelId={PUBLISH_PANEL_ID}
      isOpen={isOpen}
      toggle={toggle}
      popperClassName="dc-production-popover"
    >
      {(handleToggle) => (
        <div
          id={PUBLISH_PANEL_ID}
          className="dc-production-panel"
          role="dialog"
          aria-modal="false"
          aria-label="Publish"
          tabIndex={-1}
        >
          <div className="dc-production-panel-header">
            <div className="dc-production-panel-intro">
              <div className="dc-production-panel-heading">
                <span className="dc-production-dot" aria-hidden="true" />
                <span>Publish</span>
              </div>
              <p className="dc-production-panel-subtitle">
                Publish your app for preview or for end users.
              </p>
            </div>
          </div>
          <PreviewPublishContent
            variant="panel"
            embedded
            projectId={projectId}
            projectDetail={projectDetail}
            versions={versions}
            selVersion={selVersion}
            isPreviewPublishing={isPreviewPublishing}
            publishApp={publishApp}
            handleVersionChange={handleVersionChange}
            actions={actions}
            version={version}
          />
          <ProductionPublishContent
            variant="panel"
            embedded
            projectId={projectId}
            version={version}
            versions={versions}
            selVersion={selVersion}
            isPublishing={isPublishing}
            handleVersionChange={handleVersionChange}
            publishApp={publishApp}
            projectDetail={projectDetail}
            actions={actions}
          />
        </div>
      )}
    </HeaderAnchorPopover>
  );
};

export default PublishPopover;
